module.exports = __webpack_public_path__ + "static/corona-landing-mobile.ee473ac0.png";